import { createAsyncThunk } from '@reduxjs/toolkit';

import api from '@services/api';

const PREFIX = 'FILTERS';

export const fetchFilterOptions = createAsyncThunk(`${PREFIX}/FETCH_FILTER_OPTIONS`, async () => {
  const { data: filterOptions } = await api.get('/artworks/filters/');

  return { filterOptions };
});
